import React from "react";
import './tabela.css';
import NumberFormat from 'react-number-format';



export default class Zestawieniahtml_3 extends React.Component {
constructor(props) {
    super();
    this.state = { 
        
    }

}

render() {
const wyddoch = this.props.grupaZestawienValuetext.charAt(0);
let stopka = [this.props.data.stopka]
let dane = this.props.data.dane;

return (
<React.Fragment>
<div className="container mt-5">

<table className="tabela">
<tbody>

{/* <tr>
    <td className="td-1" colSpan="3" height="47" align="center" valign="top"><i>Sygnatura</i></td>
<td className="td-1" colSpan="9" align="center" valign="middle"><b><font size="3" color="#000080">WNIOSEK W SPRAWIE ZMIAN W PLANIE: 1) DOCHODÓW, w tym  UE  2) WYDATKÓW BIEŻĄCYCH, tym  UE  3)  WYDATKÓW MAJĄTKOWYCH, w tym  UE 4) PRZYCHODÓW 5) ROZCHODÓW *),
ZMIAN W PLANIE FINANSOWYM ZADAŃ Z ZAKRESU ADMINISTRACJI RZĄDOWEJ ORAZ INNYCH ZADAŃ ZLECONYCH MIASTU STOŁECZNEMU WARSZAWIE I ZMIAN W PLANIE WYDATKÓW URZĘDU MIASTA STOŁECZNEGO WARSZAWY</font></b></td>
    <td className="td-1" colSpan="3" align="center"></td>
</tr>

<tr>
    <td className="td-2" height="61" align="left"></td>
    <td align="left" colSpan="10"></td>
    <td align="right" height="81"><b>Adresat:</b></td>
    <td className="td-3" colSpan="3" align="center" height="61"><b><font size="3">{this.props.data.adresat}</font></b></td>
</tr>

<tr>
        <td className="td-2" height="17" align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td className="td-1" colSpan="2">Część budżetu: </td>
        <td className="td-4" colSpan="7" align="center">{this.props.data.czescBudzetu}</td>
        <td align="left"></td>
        <td align="left"></td>
        <td className="td-3" align="left"></td>
    </tr>
    <tr>
        <td className="td-2" colSpan="2" height="18" align="center" valign="bottom"></td>
        <td align="left"></td>
        <td className="td-5" colSpan="2">{wyddoch === "D" ? (<p>Dochody na zadania:</p>) : (<p>Wydatki na zadania:</p>)}</td>
        <td className="td-6" colSpan="7" align="center">{this.props.data.rodzaje}</td>
        <td align="left"></td>
        <td align="left"></td>
        <td className="td-3" align="center"></td>
    </tr>

    <tr>
        <td className="td-2" colSpan="2" height="18" align="center" valign="bottom"></td>
        <td className="" colSpan="12"></td>
        <td className="td-3" align="center"></td>
    </tr>

    <tr>
        <td className="td-2" colSpan="4" height="55" align="left" valign="bottom"><i>pieczątka wydziału</i></td>
        <td align="left" colSpan="10"><i></i></td>
        <td className="td-3" align="center"></td>
    </tr> */}

<tr>
    <td className="text-center tabela" colSpan="2" width="150"><b>Stanowisko finansowe</b></td>
    <td className="text-center tabela" colSpan="3" width="150"><b>Stanowisko finansowe</b></td>
    <td className="text-center tabela" colSpan="1" width="80"><b>Obszar funkcjonalny</b></td>
    <td className="text-center tabela" colSpan="2" width="160"><b>Program budżetowy</b></td>
    <td className="text-center tabela" colSpan="2" width="140" rowSpan="2"><b>Plan wg stanu na dzień</b></td>
    <td className="text-center tabela" colSpan="2" width="140" rowSpan="2"><b>Zaangażowanie * / Wykonanie * wg stanu na dzień</b></td>
    <td className="text-center tabela" colSpan="2" width="160"><b>Proponowane zmiany</b></td>
    <td className="text-center tabela" colSpan="2" width="80" rowSpan="2"><b>Plan po zmianach</b></td>
</tr>
<tr>
    <td className="text-center tabela" colSpan="1" width="75" ><b>Nazwa dysponenta **</b></td>
    <td className="text-center tabela" colSpan="1" width="75" ><b>Kod dysponenta</b></td>
    <td className="text-center tabela" colSpan="1" width="50"><b>Dział</b></td>
    <td className="text-center tabela" colSpan="1" width="50"><b>rozdział</b></td>
    <td className="text-center tabela" colSpan="1" width="50"><b>§</b></td>
    <td className="text-center tabela" colSpan="1" width="80" ><b>Kod</b></td>
    <td className="text-center tabela" colSpan="1" width="80" ><b>Nazwa</b></td>
    <td className="text-center tabela" colSpan="1" width="80" ><b>Kod</b></td>
    <td className="text-center tabela" colSpan="1" width="80" ><b>zmniejszenia</b></td>
    <td className="text-center tabela" colSpan="1" width="80" ><b>zwiększenia</b></td>
</tr>

{dane ? (<>
    {dane.length > 0 ? (
     dane.map((user, idx) => {
        const { nazwaWydzialu, kodWydzialu, pozycjeFin, rodzajNazwa, nazwaZadania, kodZadania, planNaDzien, zaangazowanie, zmniejszenia, zwiekszenia, planPo} = user;
        return (    
        <React.Fragment key={idx}>
            <tr key={idx}>
                <td className="text-left tabela" colSpan="1" width="75"><p className="m-1">{nazwaWydzialu}</p></td>
                <td className="text-left tabela" colSpan="1" width="75"><p className="m-1">{kodWydzialu}</p></td>
                <td className="text-left tabela" colSpan="3" width="150"><p className="m-1">{pozycjeFin}</p></td>
                <td className="text-left tabela" colSpan="1" width="80"><p className="m-1">{rodzajNazwa}</p></td>
                <td className="text-left tabela" colSpan="1" width="80"><p className="m-1">{nazwaZadania}</p></td>
                <td className="text-left tabela" colSpan="1" width="80"><p className="m-1">{kodZadania}</p></td>
                <td className="text-right tabela" colSpan="2" width="160"><p className="m-1"><NumberFormat value={planNaDzien} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
                <td className="text-right tabela" colSpan="2" width="160"><p className="m-1"><NumberFormat value={zaangazowanie} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
                <td className="text-right tabela" colSpan="1" width="80"><p className="m-1"><NumberFormat value={zmniejszenia} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
                <td className="text-right tabela" colSpan="1" width="80"><p className="m-1"><NumberFormat value={zwiekszenia} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
                <td className="text-right tabela" colSpan="1" width="80"><p className="m-1"><NumberFormat value={planPo} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
            </tr>
        </React.Fragment>
        )
    })
    ) : (
    <tr>
        <td className="text-center tabela" colSpan="15">Brak danych</td>
    </tr>
    ) } </>) : (
    <tr>
        <td className="text-center tabela" colSpan="15">Ładowanie</td>
    </tr>
    )}

<tr>
    <td className="td-2" height="30" align="left"></td>
    <td align="left" colSpan="13"></td>
    <td className="td-3" align="left"></td>
</tr>
    
<tr>
    <td className="td-2" height="17" align="left"></td>
    <td align="left">Opis:</td>
    <td align="left"></td>
    <td align="left"></td>
    <td align="left"></td>
    <td align="left"></td>
    <td align="left"></td>
    <td align="left"></td>
    <td align="left"></td>
    <td align="left"></td>
    <td align="left"></td>
    <td align="left"></td>
    <td align="left"></td>
    <td align="left"></td>
    <td className="td-3" align="left"></td>
</tr>
{this.props.data.uwagi2 ? (<>
<tr>
    <td className="td-2" height="17" align="left"></td>
    <td colSpan="13"></td>
    <td className="td-3" align="left"></td>
</tr>
<tr>
    <td className="td-2" height="17" align="left"></td>
    <td colSpan="13"><div dangerouslySetInnerHTML={ { __html: this.props.data.uwagi2 } }></div></td>
    <td className="td-3" align="left"></td>
</tr>
<tr>
    <td className="td-2" height="17" align="left"></td>
    <td colSpan="13"></td>
    <td className="td-3" align="left"></td>
</tr>

</>) : null}
    
<tr>
    <td className="td-2" height="80" align="left"></td>
    <td align="left"></td>
    <td align="left"></td>
    <td align="left"></td>
    <td align="left"></td>
    <td align="left"></td>
    <td align="left"></td>
    <td align="left"></td>
    <td align="left"></td>
    <td align="left"></td>
    <td align="left"></td>
    <td align="left"></td>
    <td align="left"></td>
    <td align="left"></td>
    <td className="td-3" align="left"></td>
</tr>

<tr>
    <td className="td-2" height="17" align="center"></td>
    <td align="left" colSpan="3"><font face="Verdana">&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;..</font></td>
    <td align="left"></td>
    <td align="center" colSpan="4"><font face="Verdana">&hellip;&hellip;&hellip;&hellip;&hellip;</font></td>
    <td align="left"></td>
    <td align="center" colSpan="3"><font face="Verdana">&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;</font></td>
    <td className="td-3" colSpan="2" align="center"><font face="Verdana">&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;..</font></td>
</tr>
<tr>
    <td className="td-2"></td>
    <td  colSpan="3" height="17" align="center"><div dangerouslySetInnerHTML={ { __html: stopka.stopkaLewo } }></div></td>
    <td align="left" ><font face="Verdana" size="1"><br></br></font></td>
    <td align="left" colSpan="4"><div dangerouslySetInnerHTML={ { __html: stopka.stopkaData } }></div></td>
    <td align="center" ><i><font face="Verdana" size="1"><br></br></font></i></td>
    <td align="center" colSpan="3"><div dangerouslySetInnerHTML={ { __html: stopka.stopkaSrodek } }></div></td>
    <td className="td-3" colSpan="2" align="center"><div dangerouslySetInnerHTML={ { __html: stopka.stopkaPrawo } }></div></td>
</tr>
<tr>
    <td className="td-8" height="17" align="left"></td>
    <td className="td-7" align="left"></td>
    <td className="td-7" align="left"></td>
    <td className="td-7" align="left"></td>
    <td className="td-7" align="left"></td>
    <td className="td-7" align="left"></td>
    <td className="td-7" align="left"></td>
    <td className="td-7" align="left"></td>
    <td className="td-7" align="left"></td>
    <td className="td-7" align="left"></td>
    <td className="td-7" align="left"></td>
    <td className="td-7" align="left"></td>
    <td className="td-7" align="left"></td>
    <td className="td-7" align="left"></td>
    <td className="td-6" align="left"></td>
</tr>

</tbody>
</table>

</div>

</React.Fragment>
);

}
}
